import React, { useState, useContext } from "react";
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  Stack,
  Box,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
//Icons
import { AiOutlineSetting } from "react-icons/ai";
import { PiStudentBold } from "react-icons/pi";
import { GiClothes } from "react-icons/gi";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { MdCategory } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa6";
import { FaDatabase } from "react-icons/fa";
import { SiGitbook } from "react-icons/si";
import { TbAdjustmentsCog } from "react-icons/tb";
import { TbReportAnalytics } from "react-icons/tb";
import { SiRetool } from "react-icons/si";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { FaOutdent } from "react-icons/fa6";
import { RiHomeOfficeFill } from "react-icons/ri";
import { RiTakeawayFill } from "react-icons/ri";
//Srcs
import "./menunavbar.scss"; 
import CompanyLogo from "../Assets/Go-Global-School.jpg";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";

const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  height: "100%",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  margin: "0px",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function MenuNavbar({ open, toggleDrawer }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  let location = useLocation();
  const navigate = useNavigate();

  const [openIncome, setOpenIncome] = useState(false);
  const handleOpenIncome = () => {
    setOpenIncome(!openIncome);
    setOpenExpenses(false);
    // toggleDrawer("left", false)
  };

  const [openExpenses, setOpenExpenses] = useState(false);
  const handleOpenExpenses = () => {
    setOpenExpenses(!openExpenses);
    setOpenIncome(false);
    // toggleDrawer("left", false)
  };

  const handleCloseSubMenu = () => {
    setOpenExpenses(false);
    setOpenIncome(false);
    toggleDrawer("left", false);
  };
  const [openMealService, setOpenMealService] = useState(false);
  const handleOpenMealService = () => {
    setOpenMealService(!openMealService);
  };

  const menuData = [
    {
      RouteTo: "/dashboard",
      Title: "ទំព័រដើម",
      Icon: <DashboardIcon className="icon" />,
    },
    {
      RouteTo: "/reqpurchase",
      Title: "ការស្នើរទិញចូល",
      Icon: <ShoppingCartIcon className="icon" />,
    },
    {
      RouteTo: "/student",
      Title: "សិស្ស",
      Icon: <PiStudentBold className="icon" />,
    }, 
    {
      RouteTo: "/studentbook",
      Title: "បើកសម្ភារៈសិស្ស",
      Icon: <RiTakeawayFill className="icon" />,
    }, 
    {
      RouteTo: "/studentrentbook",
      Title: "ជួលសម្ភារៈសិស្ស",
      Icon: <RiTakeawayFill className="icon" />,
    },
    {
      RouteTo: "/book",
      Title: "សៀវភៅ",
      Icon: <SiGitbook className="icon" />,
    },
    {
      RouteTo: "/uniform",
      Title: "ឯកសណ្ឋាន",
      Icon: <GiClothes className="icon" />,
    },
    {
      RouteTo: "/materialusing",
      Title: "សម្ភារៈប្រើប្រាស់",
      Icon: <SiRetool className="icon" />,
    },
    {
      RouteTo: "/ajustment",
      Title: "ការកែប្រែស្តុក",
      Icon: <TbAdjustmentsCog className="icon" />,
    },
    {
      RouteTo: "/Report",
      Title: "របាយការណ៍",
      Icon: <TbReportAnalytics className="icon" />,
    },    
    // {
    //   RouteTo: "/takeout",
    //   Title: "សំណើរប្រើប្រាស់",
    //   Icon: <FaOutdent className="icon" />,
    // },
    // {
    //   RouteTo: "/office-inventory",
    //   Title: "ស្តុកតាមការិយាល័យ",
    //   Icon: <RiHomeOfficeFill className="icon" />,
    // },
  ];

  return (
    <Drawer variant="permanent" open={true} className="drawer-menu">
      <DrawerHeader sx={{ mt: 2 }}>
        <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
          <IconButton
            onClick={() => navigate("/programme")}
            className="image-container"
          >
            <img src={CompanyLogo} alt="logo" className="logo" />
          </IconButton>
        </Stack>
      </DrawerHeader>

      {menuData.map((e, index) => (
        <List className="list-menu" key={index}>
          <ListItem
            disablePadding
            onClick={() => {
              navigate(e.RouteTo);
              toggleDrawer("left", false);
            }}
            className={
              location.pathname === e.RouteTo ? "list-item-active" : "list-item"
            }
          >
            <ListItemButton className="list-item-button">
              <ListItemIcon className="list-item-icon">{e.Icon}</ListItemIcon>
              <Typography className="list-item-text">{e.Title}</Typography>
            </ListItemButton>
          </ListItem>
        </List>
      ))}
      <Box sx={{ flexGrow: 1 }} />

      <List className="list-menu">
        {/* =============================== Page Setting =============================== */}
        <ListItem
          className={
            location.pathname === "/setting" ||
            location.pathname === "/setting/user" ||
            location.pathname === "/setting/warehouse" ||
            location.pathname === "/setting/section" ||
            location.pathname === "/setting/levelsection" ||
            location.pathname === "/setting/address" ||
            location.pathname === "/setting/supplier" ||
            location.pathname === "/setting/unit" ||
            location.pathname === "/setting/size" ||
            location.pathname === "/setting/group" ||
            location.pathname === "/setting/material" ||
            location.pathname === "/setting/materialname" ||
            location.pathname === "/setting/category" ||
            location.pathname === "/setting/class-needed-items" ||
            location.pathname === "/setting/office"
              ? "list-item-active"
              : "list-item"
          }
          disablePadding
          onClick={() => {
            navigate("/setting");
            handleCloseSubMenu();
          }}
        >
          <ListItemButton className="list-item-button">
            <ListItemIcon className="list-item-icon">
              <AiOutlineSetting className="icon" />
            </ListItemIcon>
            <Typography className="list-item-text">Setting</Typography>
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}
